import React from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { Carousel } from "pro-features/components/Carousel/src/Carousel";

import { SearchOverviewTexts } from "../../texts";

import SearchCardWidget from "./components/SearchCardWidget/SearchCardWidget";
import TitleFilters from "./components/TitleFilters/TitleFilters";
import { useSearchCarouselData } from "./data/useSearchCarouselData";
import { CarouselWrapper, Container } from "./styledComponents";
import { getSearchWidgetsConfig } from "./widgetConfig";
import { SearchMetricName } from "./types";

const METRICS = [
    SearchMetricName.ALL,
    SearchMetricName.ORGANIC,
    SearchMetricName.PAID,
    SearchMetricName.RANK_POSITION,
    SearchMetricName.PPC,
    SearchMetricName.BRANDED,
] as const;
const ZERO = 0;

const SearchCarousel = () => {
    const { params } = useCurrentStateAndParams();
    const { key } = params;

    const { searchMetricData, isLoading, isKeywordsLoading, isError } = useSearchCarouselData();
    const searchWidgetsConfig = getSearchWidgetsConfig();

    return (
        <Container data-automation="SearchOverviewCarousel">
            <TitleFilters title={SearchOverviewTexts.overview} />
            <CarouselWrapper>
                <Carousel
                    goToEnd
                    margin={ZERO}
                >
                    {METRICS.map((metricName, index) => (
                        <SearchCardWidget
                            key={metricName}
                            isLoading={isLoading?.[metricName]}
                            isError={isError?.[metricName]}
                            data={searchMetricData?.[metricName]?.[key]}
                            isKeywordsLoading={isKeywordsLoading?.[metricName]}
                            withBorder={index !== METRICS.length - 1}
                            {...searchWidgetsConfig[metricName]}
                        />
                    ))}
                </Carousel>
            </CarouselWrapper>
        </Container>
    );
};

export default React.memo(SearchCarousel);
